// extracted by mini-css-extract-plugin
export default {"noteHeadline":"Note_noteHeadline__Adkjf","noteDetails":"Note_noteDetails__5IqQq","skeletonWrapper":"Note_skeletonWrapper__8cyaw"};